import React, {useContext, useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import {Typography} from '@material-ui/core';
import classNames from 'classnames';

import CountDown from 'components/CountDown';
import Conf from 'utils/Conf';
import NewVideoPlayer from 'components/VideoPlayer/index';
import OldVideoPlayer from 'components/VideoPlayer';
import Link from 'components/Link';
import defaultCinemaBackground from 'assets/cinema-background.jpg';
import Context from 'utils/Context';

import './VirtualRoomScreen.scss';
import VideoResumeCountdown from './VideoResumeCountdown';
import SeanceIntro from './SeanceIntro';
import ProgressControl from './ProgressControl';

const getBackgroundStyle = seance => {
  if (!seance.background) {
    return {
      backgroundImage: `url("${defaultCinemaBackground}")`,
    };
  }
  // const basename = seance.background.split(/[\\/]/).pop();
  // const background = seance.background.replace(basename, `min/${basename}`);
  return {
    backgroundImage: `url("${Conf.assetsRoot}${seance.background}")`,
  };
};

const VirtualRoomScreen = ({seance, onTogglePause, timings, obtainAWSAuthCookie}) => {
  const {t} = useTranslation();
  const {methods, appState} = useContext(Context);
  const [hasCookie, setHasCookie] = useState(false);

  const handleVolumeChange = useCallback(vol => methods.setAppState({volume: vol}), [methods]);

  const {
    seanceStartAt,
    screenOn,
    onEndCurrentVideo,
    onPlayerTimeUpdate,
    onChangeTimecode,
    liveStarted,
    toggleWatchLive,
    currentVideo,
    canResumeFilm,
    min,
    max,
    seanceStatus,
    onTogglePlay,
    paused,
  } = timings;

  console.log('rerender VirtualRoomScreen', timings);

  if (!seance) {
    return null;
  }

  const renderCurrentVideo = () => {
    if (seanceStatus !== 'playing') {
      return null;
    }
    switch (currentVideo.name) {
      case 'intro':
        return <SeanceIntro onEnd={onEndCurrentVideo} />;
      case 'jingle':
        return (
          <OldVideoPlayer
            video={seance.jingle_id}
            autoplay
            hideControls
            onPlayRequest={() => {}}
            onPauseRequest={() => {}}
            onTogglePlayRequest={() => {}}
            // onTimeUpdate={onPlayerTimeUpdate}
            onEnd={onEndCurrentVideo}
            startTimecode={currentVideo.videoStartTimecode}
            // onPlay={this.handlePlay}
            // onPause={this.handlePause}
            // node={this.salleRef.current}
            // onShowControls={this.handleShowControls}
            // onHideControls={this.handleHideControls}
          />
        );
      case 'global_trailer':
        return (
          <OldVideoPlayer
            video={seance.bande_annonce_admin}
            autoplay
            hideControls
            onPlayRequest={() => {}}
            onPauseRequest={() => {}}
            onTogglePlayRequest={() => {}}
            // onTimeUpdate={onPlayerTimeUpdate}
            onEnd={onEndCurrentVideo}
            startTimecode={currentVideo.videoStartTimecode}
          />
        );
      case 'seance_trailer':
        return (
          <OldVideoPlayer
            video={seance.intro_id}
            autoplay
            hideControls
            onPlayRequest={() => {}}
            onPauseRequest={() => {}}
            onTogglePlayRequest={() => {}}
            // onTimeUpdate={onPlayerTimeUpdate}
            onEnd={onEndCurrentVideo}
            startTimecode={currentVideo.videoStartTimecode}
          />
        );
      case 'film':
        if (!hasCookie) {
          obtainAWSAuthCookie(seance.media_video_path, () => {
            setHasCookie(true);
          });
          return null;
        }
        return (
          <div className="video-player-container">
            <NewVideoPlayer
              src={currentVideo.src}
              type="application/x-mpegURL"
              // poster
              // width = 640
              // height = 264
              // controls={video.started}
              autoplay
              volume={appState.volume}
              // muted = false,
              // fullscreen = false,
              startTimecode={currentVideo.videoStartTimecode}
              onTimeUpdate={onPlayerTimeUpdate}
              onPause={onTogglePause}
              onEnd={onEndCurrentVideo}
              onVolumeChange={handleVolumeChange}
              onTogglePlay={onTogglePlay}
              paused={paused}
            />
            <ProgressControl
              duration={currentVideo.duration}
              current={currentVideo.currentTimecode}
              min={min}
              max={max}
              onChange={onChangeTimecode}
            />
          </div>
        );
      case 'live':
        return (
          <OldVideoPlayer
            video={seance.live_id}
            autoplay
            onPlayRequest={() => {}}
            onPauseRequest={() => {}}
            onTogglePlayRequest={() => {}}
            startTimecode={currentVideo.videoStartTimecode}
            // onTimeUpdate={onPlayerTimeUpdate}
            // onPlay={this.handlePlay}
            // onPause={this.handlePause}
            // node={this.salleRef.current}
            // onShowControls={this.handleShowControls}
            // onHideControls={this.handleHideControls}
            isLive
          />
        );
      case 'waiting':
      case 'ended':
      default:
        return null;
    }
  };

  const renderMsg = () => {
    if (seanceStatus === 'ended') {
      return (
        <div style={{backgroundColor: 'black'}}>
          {t('cette-seance-est-terminee')}
          <br />
          <Typography variant="body1">
            <Link url="/">{t('retour-a-l-accueil')}</Link>
          </Typography>
        </div>
      );
    }

    if (!screenOn) {
      return <CountDown startAt={seanceStartAt.format()} />;
    }

    return null;
  };

  return (
    <div className="virtual-room-screen">
      <div className="room-background" style={getBackgroundStyle(seance)}>
        <div className="screen-messages">
          <div className="screen-messages-inner">{renderMsg()}</div>
        </div>
      </div>
      <div className={classNames('seance-players', {show: screenOn})}>
        {seanceStatus === 'playing' && currentVideo.name === 'film' && liveStarted && (
          <div className="seance-osd">
            <Button color="primary" size="small" variant="outlined" onClick={() => toggleWatchLive(true)}>
              {t('quitter-le-film-pour-rejoindre-la-rencontre')}
            </Button>
          </div>
        )}
        {seanceStatus === 'playing' && currentVideo.name === 'live' && canResumeFilm && (
          <div className="seance-osd">
            <Button color="primary" size="small" variant="outlined" onClick={() => toggleWatchLive(false)}>
              {t('reprendre-le-film')}
            </Button>
          </div>
        )}
        {renderCurrentVideo()}
        {seanceStatus === 'playing' &&
          (!seance.event_id || currentVideo.currentTimecode < currentVideo.duration - appState.conf.RETARD_MAX * 60) &&
          currentVideo.name !== 'live' &&
          paused && <VideoResumeCountdown remaining={currentVideo.currentTimecode - min} />}
      </div>
    </div>
  );
};

export default VirtualRoomScreen;
